// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__envYk","productName":"Table_productName__19syI"};